import React from 'react'
import { connect } from 'react-redux'
import { programUpdateRequest } from '../actions/index'
import getData from '../functions/getData'
import { PROGRAM_STATUS, PROGRAM_ERROR } from '../constants/state'


const mapStateToProps = state => ({
    programStatus: getData(state, PROGRAM_STATUS),
    programError: getData(state, PROGRAM_ERROR)
})


const mapDispatchToProps = dispatch => ({
    onUpdateProgram: () => {
        dispatch(programUpdateRequest())
    }
})

const hasUpdateProgram = () => WrappedComponent => {
    const HasUpdateProgram = props => <WrappedComponent {...props} />

    return connect(mapStateToProps, mapDispatchToProps)(HasUpdateProgram)
}


export default hasUpdateProgram